(() => {
  const setupHeaderScrollEffect = () => {
    const header = document.querySelector('#header-component');
    if (!header || header.dataset.beamboxScrollReady === 'true') return;

    // 主题编辑器重新渲染区块时先清理旧监听，避免重复执行
    window.__beamboxHeaderScrollCleanup?.();
    header.dataset.beamboxScrollReady = 'true';

    let lastScrollY = window.scrollY;
    let framePending = false;

    // 根据滚动方向控制导航显示状态，减少快速滚动时的频繁重排
    const updateHeaderVisibility = () => {
      framePending = false;

      const currentScrollY = Math.max(window.scrollY, 0);
      const scrollDelta = currentScrollY - lastScrollY;

      if (currentScrollY <= 12 || scrollDelta < -2) {
        header.classList.remove('beambox-header--hidden');
        header.classList.add('beambox-header--visible');
      } else if (scrollDelta > 2) {
        header.classList.remove('beambox-header--visible');
        header.classList.add('beambox-header--hidden');
      }

      lastScrollY = currentScrollY;
    };

    const handleScroll = () => {
      if (framePending) return;
      framePending = true;
      window.requestAnimationFrame(updateHeaderVisibility);
    };

    header.classList.add('beambox-header--visible');
    window.addEventListener('scroll', handleScroll, { passive: true });

    window.__beamboxHeaderScrollCleanup = () => {
      window.removeEventListener('scroll', handleScroll);
      delete window.__beamboxHeaderScrollCleanup;
    };
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupHeaderScrollEffect, { once: true });
  } else {
    setupHeaderScrollEffect();
  }
})();
